import React from 'react';
import { Button } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons';

const EmptyAttribute = ({ text, onClick }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <Button
        ghost
        type='text'
        shape='round'
        onClick={onClick}
        size='large'
        icon={<PlusCircleOutlined />}
        style={{ fontSize: '18px', color: '#8c8c8c' }}
      >
        Click or drag attributes to this area to create {text}.
      </Button>
    </div>
  );
};

export default EmptyAttribute;
